import { forwardRef, useEffect, useRef } from 'react';

export default forwardRef(function TextInput({ type = 'text', className = '', isFocused = false, ...props }, ref) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const input = ref ? ref : useRef();

    useEffect(() => {
        if (isFocused) {
            input.current.focus();
        }
    }, [input, isFocused]);

    return (
        <input
            {...props}
            type={type}
            className={
                'p-3 border border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 rounded-md shadow-md ' +
                className
            }
            ref={input}
        />
    );
});
